import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as limbo from "../../api/limboApi";
import { LogLevel } from "@microsoft/signalr";
const signalR = require("@microsoft/signalr");

class OurLogger {
    log(logLevel, message) {
        // adjust the if condition as required (logLevel > -1 means all log levels are logged)
        if (logLevel > -1) { // 0 = Trace, 1 = Debug, 2 = Information, 3 = Warning, 4 = Error, 5 = Critical, 6 = None
            const logLevelString = LogLevel[logLevel] ? LogLevel[logLevel] : "Log";
            logUI("UI.SignalRListener." + logLevelString, new Date(), Tools.getURLPath(), message);
        }
    }
}

/**
 * Container component for the dashboard page.
 * 
 */
class SignalRListener extends React.Component {
    constructor(props) {
        super(props);
        //console.log("Dashboard constructor...");

        this.establishConnection = this.establishConnection.bind(this);
        //debugger;
        this.state = {
            ListenerStarted: false,
        };

        this.onGuestApprovalWaiting = this.onGuestApprovalWaiting.bind(this);
    }

    componentDidCatch(ex, info) {
        let json = { error: ex, componentStack: info };
        //logUI("MBHWeb.UI.Dashboard.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("UI.SignalRListener.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(ex), JSON.stringify(info));
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { signalRToken, signalRUrl, eid, providerJWT, instaDocToken } = this.props;
        const { ListenerStarted } = this.state;
        const prevToken = prevProps.signalRToken;
        if (!ListenerStarted && eid && instaDocToken) {
            logUI("UI.SignalRListener.EstablishConnection", new Date(), Tools.getURLPath());
            this.establishConnection(signalRToken, instaDocToken, signalRUrl, eid);
        }
    }

    establishConnection(sSignalRToken, sInstaDocToken, sURL, sEID) {
        const { RefreshData, setParticipants } = this.props;
        var connection = new signalR.HubConnectionBuilder()
            //.withUrl(sURL, { accessTokenFactory: () => sSignalRToken })
            .withUrl(Tools.buildUrl(window.serverData.data.limboBaseUrl, "/api"), { accessTokenFactory: () => sInstaDocToken })
            //.configureLogging(LogLevel.Information)
            .configureLogging(new OurLogger())
            .withAutomaticReconnect()
            .build();

        connection.parent = this;

        connection.onclose(err => {
            console.err(err);
            logUI("UI.SignalRListener.ConnectionError", new Date(), Tools.getURLPath(), err);
        });

        connection.onreconnected(data => {
            console.log(data);
        });

        connection.onreconnecting(data => {
            console.log(data);
        });

        connection.on("epicRoomChanged", data => {
            console.log(data);
            const now = new Date();
            logUI("UI.SignalRListener.epicRoomChanged", now, Tools.getURLPath(), data);
            let allParticipants = JSON.parse(JSON.parse(sessionStorage['root']).videoVisit)?.participants || [];
            const matchingParticipants = allParticipants.filter(p => p.roomId = data.id);
            const patients = data.onlineParticipants?.length ? data.onlineParticipants.filter(p => p.participantRole == 'Patient') : [];
            if (matchingParticipants.length > 0) {
                let i = 0;
                while (i < matchingParticipants.length) {
                    const participant = matchingParticipants[i];
                    if (!patients.find(p => p.participantId == participant.participantId)) {
                        const diffMs = (now - new Date(participant.connectedTime)); // milliseconds between the times
                        const diffMins = (((diffMs % 86400000) % 3600000) / 60000).toFixed(2); // minutes
                        logUI("UI.Twilio.Participant.DisConnected", now, Tools.getURLPath(), { participant }, data.id, diffMins);
                        matchingParticipants.splice(i, 1);
                    }
                    else {
                        i++;
                    }
                }
            }
            else {
                patients.forEach(p => {
                    matchingParticipants.push({ roomId: data.id, participantId: p.participantId, connectedTime: now });
                });
            }
            allParticipants = matchingParticipants.concat(allParticipants.filter(p => p.roomId != data.id));
            setParticipants(allParticipants);

            RefreshData(data);
        });

        connection.on("sigrtest", data => {
            console.log(data);
        });

        connection.on("onGuestWaitingForApproval", this.onGuestApprovalWaiting);

        connection.start()
            .then(() => {
                //connection.invoke("sigrtest", "Hello");
                //        limbo.SubscribeProvider(sInstaDocToken, sEID);
                //        limbo.SubscribeProvider(sInstaDocToken, window.serverData.data.sameDayCareProviderId);
                let timer = setInterval(() => {
                    const domain = JSON.parse(JSON.parse(sessionStorage['root']).domain);
                    const { eid, eids, sdc, er } = domain;
                    if (eids !== null) {
                        clearInterval(timer);
                        if (er !== 'staff') {
                            for (let i = 0; i < eids.length; i++) {
                                limbo.SubscribeProvider(sInstaDocToken, eids[i].providerExternalId);
                            }
                        }
                        else {
                            limbo.SubscribeProvider(sInstaDocToken, eid);
                        }
                        if (sdc) {
                            limbo.SubscribeProvider(sInstaDocToken, '153284');
                        }
                    }
                }, 3000);
            });


        this.setState({ ListenerStarted: true });
    }

    onGuestApprovalWaiting(data) {
        logUI("UI.SignalRListener.onGuestWaitingForApproval", new Date(), Tools.getURLPath(), Tools.getURLPath(), data);
        const { guestApprovalStatus } = this.props;
        guestApprovalStatus(data);
    }
    render() {
        return <div />;
    }
}

const mapStateToProps = (state) => {
    //debugger;

    const windowDefined = typeof window !== 'undefined';
    //console.log("Dashboard.mappingStateToProps... state = " + JSON.stringify( state));

    return {
        signalRToken: state.domain.srt,
        signalRUrl: state.domain.sru,
        eid: state.domain.eid,
        providerJWT: state.portal.providerJWT,
        instaDocToken: state.domain.idt,
        participants: state.videoVisit.participants
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAppointment: (oAppointment) => {
            dispatch({ type: types.SIGNALR_UPDATE_ROOM, room: oAppointment });
        },
        RefreshData: (data) => {
            dispatch({ type: types.APPOINTMENTS_REFRESH_DATA, NoSync: true, data });
        },
        guestApprovalStatus: (data) => {
            dispatch({ type: types.GUEST_LINK_APPROVAL_STATUS, data });
        },
        setParticipants: (participants) => dispatch({ type: types.SET_PARTICIPANTS, participants })
    };
};

const SignalRListenerComp = withRouter(connect(mapStateToProps, mapDispatchToProps)(SignalRListener));

export default SignalRListenerComp;
